import { Device } from '../../types';

export interface Props {
  device: Device;
  setSelectedDevice: (device: Device | null) => void;
}

export enum Step {
  VIEW = 'VIEW',
  BLOCK = 'BLOCK',
  BLOCK_SUCCESS = 'BLOCK_SUCCESS',
  UNBLOCK = 'UNBLOCK',
  UNBLOCK_SUCCESS = 'UNBLOCK_SUCCESS',
}
